import React, { createContext, useState } from "react";
import PMSExpenseCategoryServices from "../../services/pms_services/PMSExpenseCategoryServices";
import Notification from "../../components/common/Notification";

export const PMSExpenseCategoryContext = createContext("PMSExpenseCategoryContext");

const PMSExpenseCategoryContextProvider = ({ children }) => {

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [expenseCategories, setExpenseCategories] = useState([]);
    const [totalElements, setTotalElements] = useState(0);

    const getAllExpenseCategoriesByPharmacyId = async (pharmacyId, params = {}) => {
        try {
            setLoading(true);
            setErrorMsg("");

            console.log("Fetching expense categories for pharmacy:", pharmacyId, "with params:", params);
            const res = await PMSExpenseCategoryServices.getAllExpenseCategoriesByPharmacyId(pharmacyId, params);

            console.log("Expense categories response:", res.data);
            setExpenseCategories(res.data.content || res.data || []);
            setTotalElements(res.data.totalElements || res.data.length || 0);
            setLoading(false);
            return res.data.content || res.data || [];
        } catch (error) {
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            setErrorMsg(_error);
            console.error("Error fetching expense categories:", error);
            return [];
        }
    };

    const createExpenseCategoryByPharmacyId = async (id, data) => {

        try {
            setLoading(true);
            setErrorMsg("");

            await PMSExpenseCategoryServices.createExpenseCategoryByPharmacyId(id, data);

            Notification("success", "Added", "Expense category has been added successfully!");

            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }

            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    }

    return (
        <PMSExpenseCategoryContext.Provider
            value={{
                loading,
                errorMsg,
                expenseCategories,
                totalElements,
                getAllExpenseCategoriesByPharmacyId,
                createExpenseCategoryByPharmacyId
            }}
        >
            {children}
        </PMSExpenseCategoryContext.Provider>
    )
}

export default PMSExpenseCategoryContextProvider;
